import {Pipe, PipeTransform} from '@angular/core';

/**
 * 字符串截断
 */
@Pipe({name: 'textTruncate'})
export class TextTruncatePipe implements PipeTransform {
    transform(value: any, maxLength: number) {
        if (!value) { return ''; }
        if (!maxLength) { return value; }
        value = value.substr(0, maxLength);
        return value + '...';
    }
}

/**
 * 字符串截断（此方法已过期，使用textTruncate代替）
 */
@Pipe({name: 'textLengthSet'})
export class TextLengthSetPipe extends TextTruncatePipe {}
